import { Modal } from 'bootstrap';

const MobileMenu = (header, selectors, attributes) => {
  let isOpen = false;
  const root = document.documentElement;
  const { mobileMenuOpen } = attributes;
  const { mobileMenu, openMobileMenuTrigger, closeMobileMenuTrigger } = selectors;

  const menu = header.querySelector(mobileMenu);
  const modalInstance = Modal.getOrCreateInstance(menu);
  const openTrigger = header.querySelector(openMobileMenuTrigger);
  const closeTrigger = header.querySelector(closeMobileMenuTrigger);
  const megaMenuClose = [...header.querySelectorAll('[data-mobile-close]')];

  const menuOnResize = (width = 992) => {
    if (window.innerWidth > width) {
      modalInstance.hide();
      root.removeAttribute(mobileMenuOpen);
      isOpen = false;
    }
  }

  const toggleMenu = () => {
    isOpen = !isOpen;
    root.toggleAttribute(mobileMenuOpen, isOpen);
  }

  const init = () => {
    openTrigger.addEventListener('click', toggleMenu);
    closeTrigger.addEventListener('click', toggleMenu);
    megaMenuClose.forEach((trigger) => trigger.addEventListener('click', () => {
      header.removeAttribute('data-mega-menu-open');
    }));
  }

  return { init, menuOnResize };
};

export default MobileMenu;
